import { List, ListItem, Typography, Divider } from "@mui/material"
import { FilterRadioGroup, FilterDatePicker, FilterAutoComplete } from "components/inputs/FilterFields"
import CustomerAutocomplete from "../../../components/inputs/Autocomplete/CustomerAutocomplete"
import { customerList } from "../../../models/customer"
import DynamicMultipleAutocomplete from "../../../components/inputs/Autocomplete/DynamicMultipleAutocomplete"
import { FilterSelect } from "../../../components/inputs/FilterFields"


/**
 * Advanced filter panel for Order List
 */
export const OrderListFilter = ({ filters = [], setFilters, value = [], onChange }) => {

    const handleChange = (name, data) => {
        const others = filters.filter((item) => item.field != name)
        setFilters(others.concat(data))
    }
    const status = [
        { value: 'pending', text: 'Pending' },
        { value: 'confirmed', text: 'Confirmed' },
        { value: 'processing', text: 'Processing' },
        { value: 'delivered', text: 'Delivered' },
        { value: 'cancelled', text: 'Cancelled' },
    ]

    const paymentStatus = [
        { value: 'paid', text: 'Paid' },
        { value: 'unpaid', text: 'Unpaid' },
        { value: 'partial', text: 'Partially Paid' },
    ]

    const daysPeriod = [
        { value: 'Early Morning', text: 'Early Morning' },
        { value: 'Morning', text: 'Morning' },
        { value: 'Afternoon', text: 'Afternoon' },
        { value: 'Evening', text: 'Evening' },
        { value: 'Night', text: 'Night' },
    ]

    const dateScopeOptions = [
        { value: 'All', text: 'All' },
        { value: 'Today', text: 'Today' },
    ]

    return (
        <List>
            <ListItem>
                <Typography variant="h5">Filter Orders</Typography>
            </ListItem>

            <Divider flexItem />

            <ListItem>
                <FilterRadioGroup name="status" data={status} label="Order Status" filters={filters} onChange={handleChange} />
            </ListItem>

            <Divider flexItem />
            <ListItem sx={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                <FilterAutoComplete name="customer_id" label="Customer" filters={filters} onChange={handleChange} field={(value, onChange) => (
                    <DynamicMultipleAutocomplete initialValue={value} setFieldValue={onChange} fetchList={customerList} fieldName="name" />
                )} />
            </ListItem> 

            <Divider flexItem />

            {/* <ListItem>
                <FilterRadioGroup name="payment_status" data={paymentStatus} label="Payment Status" filters={filters} onChange={handleChange} />
            </ListItem> */}

            <Divider flexItem />
          
            <ListItem>
                <FilterDatePicker name="from_date" label="From Date" filters={filters} onChange={handleChange} />
            </ListItem>
            <ListItem sx={{ py: 2, '& .MuiAutocomplete-inputRoot' : { py: '6px !important' } }}>
                <FilterDatePicker name="to_date" label="To Date" filters={filters} onChange={handleChange} />
            </ListItem>

            <ListItem sx={{ py: 2, '& .MuiAutocomplete-inputRoot' : { py: '6px !important' } }}>
                <FilterRadioGroup name="date_scope" data={dateScopeOptions} label="Show Orders" filters={filters} onChange={handleChange} />
            </ListItem>

            <ListItem sx={{ py: 2, '& .MuiAutocomplete-inputRoot' : { py: '6px !important' } }}>
                <FilterSelect name="day_period" label="Preferred Time Period" filters={filters} data={daysPeriod} onChange={handleChange} />
            </ListItem>
                    
        </List>
    )
}
